import type { BaseModelStepShape } from '..'

export const spaceActions = ['full', 'readwrite', 'read'] as const

export type SpaceRole = typeof spaceActions[number]

export interface AccessPrincipal {
  principal_type: 'user' | 'group'
  principal_uuid: string
}

export interface UserStep extends BaseModelStepShape {
  step_type: 'user'
  id: string
  name: string
  role: SpaceRole
}

export interface GroupStep extends BaseModelStepShape {
  step_type: 'group'
  id: string
  name: string
  role: SpaceRole
}

export type SpaceMembersType = UserStep | GroupStep

/** POST '/${MODELER_SPACES}' */
export interface SpacePostBody {
  name: string
  description: string
}

/** PUT '/space/${space_id}' */
export interface SpacePutBody {
  resource_type: 'space'
  resource_uuid: string
  action: SpaceRole
  aces: AccessPrincipal[]
}

/** GET '/${MODELER_SPACES}/{space_id}' */
export interface Space extends SpacePostBody {
  id: string
  created?: string
  updated?: string
  is_global: boolean
}

/** GET '/${MODELER_SPACES}' */
export type GetSpacesResponse = Space[]

type SpaceAccessRole = 'admin' | 'user' | 'viewer'

const RESOURCE_ACCESS = [
  'full',
  'readwrite',
  'read'
] as const

export const SPACE_ACCESS = {
  admin: RESOURCE_ACCESS[0],
  user: RESOURCE_ACCESS[1],
  viewer: RESOURCE_ACCESS[2]
}

export type ResourceAccessType = typeof RESOURCE_ACCESS[number]

/** GET '/${ACL_SERVICE}/space/${space_id}/current_user' */
export interface SpaceAccess {
  principal_uuid: string
  role: SpaceAccessRole
  resource_type: 'space'
  resource_uuid: string
  resource_access: ResourceAccessType[]
}

export interface ConflictsSummary {
  total_count: number
  total_conflicts: number
  items: string[]
}

export interface CountSummary {
  total_count: number
}

export interface DuplicationConflictsSummary {
  models: ConflictsSummary
  suites: ConflictsSummary
  tags: ConflictsSummary
  requirement_groups: ConflictsSummary
  requirements: ConflictsSummary
  custom_scripts: ConflictsSummary
  suts: ConflictsSummary
  sut_criteria: ConflictsSummary
  test_config_tags: ConflictsSummary
  integrations: ConflictsSummary
  webhooks: ConflictsSummary
  test_cases: CountSummary
  test_configs: CountSummary
}

export type ConflictAssetType =
  'models'
  | 'suites'
  | 'tags'
  | 'requirement_groups'
  | 'requirements'
  | 'custom_scripts'
  | 'suts'
  | 'sut_criteria'
  | 'test_config_tags'
  | 'integrations'
  | 'webhooks'

export interface SpaceRouteUrlQuery {
  loginSpaceId?: string
}
